import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './quasar'
import VueTimers from 'vue-timers'
import VueGtm from 'vue-gtm'
import Analytics from "./analytics"

Vue.config.productionTip = false

Vue.use(VueTimers)
Vue.use(VueGtm, {
  id: 'GTM-TZ2KC3GM'
})


Vue.use(Analytics, {
  category: process.env.VUE_APP_ANALYTICS_EVENT_CATEGORY
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

